// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2L_fm","left":"styles_left__8A44g"};